<template>
  <el-date-picker
    v-model="defaultValue"
    type="daterange"
    value-format="yyyy-MM-dd"
    :picker-options="pickerOptions"
    :default-time="['00:00:00', '23:59:59']"
    @change="valueChange"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    size="small"
    style="width: unset"
  />
</template>

<script>
import moment from "moment";

export default {
  name: "index.vue",
  props: {
    paramDateArr: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      defaultValue: [],
      pickerMinDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickerMinDate = new Date(minDate).getTime();
          if (maxDate) {
            this.defaultValue = [
              moment(minDate).format("YYYY-MM-DD"),
              moment(maxDate).format("YYYY-MM-DD")
            ];
            this.$emit("update:paramDateArr", this.defaultValue);
            this.pickerMinDate = null;
          }
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            let minValue = this.pickerMinDate - 1000 * 60 * 60 * 24 * 30,
              maxValue = 1000 * 60 * 60 * 24 * 30 + this.pickerMinDate;
            // let maxValue = (1000 * 60 * 60 * 24 * 30) + this.pickerMinDate
            let maxDate = moment().isAfter(maxValue) ? maxValue : moment();
            return time.getTime() < minValue || time.getTime() > maxDate; //注意是||不是&&
          } else {
            return time.getTime() > moment();
          }
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  beforeMount() {
    // this.count_end_time();
    this.turnTime();
  },
  methods: {
    turnTime() {
      this.defaultValue = this.latelyWeek();
      this.$emit("update:paramDateArr", this.defaultValue);
    },
    count_end_time() {
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let day = new Date().getDate();
      let month_str = month >= 10 ? month.toString() : "0" + month;
      let day_str = day >= 10 ? day.toString() : "0" + day;
      let str = year + "/" + month_str + "/" + day_str + " " + "23:59:59";
      let maxDate = new Date(str).getTime();
      this.pickerOptions.disabledDate = time => {
        return (
          time > maxDate ||
          time < new Date().getTime() - 31 * 24 * 60 * 60 * 1000
        );
      };
    },
    valueChange(val) {
      this.$emit("update:paramDateArr", val || []);
    },
    //最近一周
    latelyWeek() {
      let endTime = moment().format("YYYY-MM-DD");
      let startTime = moment()
        .subtract(6, "days")
        .format("YYYY-MM-DD");
      console.log("startTime", startTime, "endTime", endTime);
      return [startTime, endTime];
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// components/date-picker/index.vue